// extracted by mini-css-extract-plugin
export default {"modalBody":"_ModalContext_modalBody__PThTl"};